import Api from '@/helpers/api';
/**
 * Obtiene la lista de origenes de datos
 *
 * @returns {Promise<Origins>} Promise - una promesa con la lista de origenes // Error
 */
const getAllOrigins = async () => {
    const result = await Api.get('/origins');
    return result.data;
};

/**
 * Obtiene un origen de datos, por su ID.
 *
 * @param {string} id - el Id del origen
 * @returns {Promise<Origins>} Promise una promesa con el estado del servicio // Error
 */
const getOneOrigin = async (id) => {
    const result = await Api.get(`/origins/${id}`);
    return result.data;
};

/**
 * Elimina un origen de datos
 *
 * @param {string} id - el Id del origen
 * @returns {Promise<Origins>} Promise - una promesa con el estado del servicio // Error
 */
const deleteOrigin = async (id) => {
    const result = await Api.delete(`/origins/${id}`);
    return result.data;
};

export { getAllOrigins, getOneOrigin, deleteOrigin };
